// The named definitions a line sits in (`mod tests › fn freezes`), from the
// scopes the engine returns with a side's highlight.
import type { Block, Scope } from '../engine/types';

/**
 * The scopes containing 1-based `line`, outer first. `scopes` are in the
 * engine's order: by start line, outer before inner.
 */
export function scopePath(scopes: readonly Scope[], line: number): Scope[] {
  const out: Scope[] = [];
  for (const s of scopes) {
    if (s.startLine > line) break;
    if (line <= s.endLine) out.push(s);
  }
  return out;
}

/**
 * The scopes a change block sits in: those of its first added line on the
 * new side, else of its first removed line on the old side (the line the
 * engine titles the block by). Null while that side's scopes are unknown,
 * or when the block changes no line.
 */
export function blockScope(block: Block, oldScopes: readonly Scope[] | null, newScopes: readonly Scope[] | null): Scope[] | null {
  const add = block.rows.find((r) => r.kind === 'add' && r.new !== null);
  if (add) return newScopes && scopePath(newScopes, add.new!);
  const del = block.rows.find((r) => r.kind === 'del' && r.old !== null);
  if (del) return oldScopes && scopePath(oldScopes, del.old!);
  return null;
}

/** The scopes of a line on its own side (`LEFT` is the old side); null while that side's scopes are unknown. */
export function sideScope(
  at: { side: 'LEFT' | 'RIGHT'; line: number },
  oldScopes: readonly Scope[] | null,
  newScopes: readonly Scope[] | null,
): Scope[] | null {
  const scopes = at.side === 'LEFT' ? oldScopes : newScopes;
  return scopes && scopePath(scopes, at.line);
}
